import { render, staticRenderFns } from "./NotificationsTable.vue?vue&type=template&id=19c6f250&scoped=true&"
import script from "./NotificationsTable.vue?vue&type=script&lang=js&"
export * from "./NotificationsTable.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsTable.vue?vue&type=style&index=0&id=19c6f250&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c6f250",
  null
  
)

export default component.exports